import { Helmet } from 'react-helmet-async';
import { useState } from "react";
import { HiOutlineDocumentDuplicate } from 'react-icons/hi';
import { AiOutlineCheck } from 'react-icons/ai';
import "./Contact.css";
import "../../ParafiaWizytowka.css";
import { parishData } from "../../data/contactData.js"
import ChurchImage from "./ChurchImage/ChurchImage.js"

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const accountNumber = parishData.accountNumber;
  const streets = parishData.streets
  const phoneNumber = parishData.phone
  const email = parishData.email

  const copyToClipboard = (text) => {
    const fallbackCopy = (textToCopy) => {
      const textarea = document.createElement("textarea");
      textarea.value = textToCopy;
      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, 99999);
      
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          setCopied(true);
          setTimeout(() => setCopied(false), 2500);
        } else {
          alert("Nie udało się skopiować numeru konta.");
        }
      } catch (err) {
        console.error("Fallback copy failed:", err);
        alert("Nie udało się skopiować numeru konta.");
      }
      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2500);
        })
        .catch((err) => {
          console.error("Clipboard API failed:", err);
          fallbackCopy(text);
        });
    } else {
      fallbackCopy(text);
    }
  };

  const getStreetsDescription = () => {
    if (!streets || streets.length === 0) return '';
    const streetList = streets.slice(0, 10).join(', ');
    if (streets.length > 10) {
      return `${streetList} i ${streets.length - 10} innych.`;
    }
    return streetList;
  };

  return (
    <>
      <Helmet>
        <title>Kontakt – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={`Dane kontaktowe parafii św. Urszuli Ledóchowskiej w Częstochowie. Adres: ${parishData.address}. Telefon: ${phoneNumber}. Email: ${email}. Numer konta bankowego. Ulice należące do parafii: ${getStreetsDescription()}. Godziny otwarcia kancelarii.`} />
        <meta name="keywords" content="kontakt, parafia Częstochowa, adres parafii, numer telefonu parafia, email parafia, kancelaria parafialna, msze św., św. Urszula Ledóchowska, Wrzosowiak" />
        <meta property="og:title" content="Kontakt – Parafia św. Urszuli Ledóchowskiej w Częstochowie" />
        <meta property="og:description" content={`Skontaktuj się z parafią św. Urszuli Ledóchowskiej. Adres: ${parishData.address}. Telefon: ${phoneNumber}. Email: ${email}. Sprawdź mapę dojazdu i ulice należące do parafii.`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/kontakt" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kontakt – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content={`Adres, telefon, email i mapa dojazdu do parafii św. Urszuli Ledóchowskiej w Częstochowie.`} />
      </Helmet>

      <div className="contact-container">
        <div className="contact-section">
          <h2 className="section-title">Kontakt i dane parafii</h2>

          <div 
            className="account-number-card"
            onClick={() => copyToClipboard(accountNumber)}
            style={{ cursor: 'pointer' }}
          >
            <span className="info-label-account">Numer konta bankowego:</span>
            <div className="account-number-wrapper">
              <span className="account-number">{accountNumber}</span>
            </div>
            <div className="copy-icon-desktop">
              <HiOutlineDocumentDuplicate style={{ width: "20px", height: "20px", color: "#A38668" }} />
            </div>
          </div>

          <div className="mobile-contact">
            <a href={`mailto:${email}`} className="contact-tile email">
              <span className="icon">✉️</span>
              <span className="text">Napisz e-mail</span>
            </a>

            <a href={`tel:${phoneNumber}`} className="contact-tile phone">
              <span className="icon">📞</span>
              <span className="text">Zadzwoń</span>
            </a>
          </div>

          <div className="contact-visual">
            <div className="contact-image">
              <ChurchImage photos={parishData.photos} />
            </div>
            <div className="contact-map">
              <iframe
                title="Mapa dojazdu do parafii św. Urszuli Ledóchowskiej w Częstochowie"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2522.784932032353!2d19.12983217656911!3d50.77956027165692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4710b5865033f017%3A0x7c80ea7d5c6942da!2sParafia%20Katolicka%20pw.%20%C5%9Bw.%20Urszuli%20Led%C3%B3chowskiej!5e0!3m2!1spl!2spl!4v1759759737785!5m2!1spl!2spl"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: "12px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          <div className="contact-content">
            <div className="contact-info">
              <h3 className="street-title">Kościół parafialny: </h3>
              <div className="info-row">
                <span className="info-label">Adres:</span>
                <span className="info-value">
                  {parishData.address}
                </span>
              </div>
              <div className="info-row">
                <span className="info-label">Telefon:</span>
                <span className="info-value">{parishData.phone}</span>
              </div>
              {parishData.email?.trim() && (
                <div className="info-row">
                  <span className="info-label">Email:</span>
                  <span className="info-value">{parishData.email}</span>
                </div>
              )}
            </div>
            <div className="street-list">
              <h3 className="street-title">Ulice należące do parafii:</h3>
              <ul>
                {streets && streets.length > 0 ? (
                  streets.map((street, index) => (
                    <li key={index} className="street-item">
                      {street}
                    </li>
                  ))
                ) : (
                  <li className="street-item">Brak danych</li>
                )}
              </ul>
            </div>
          </div>

          <div className={`snackbar ${copied ? "show" : ""}`}>
            Skopiowano numer konta!
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;